import { CreateConfig } from '@carvana/analytics';
import type { IConfig } from '@carvana/analytics/config';
import GoogleTagManagerClient from './google-tag-manager-client';

// `gtm` is not one of IConfig's declared client keys, but it is the key the app has
// always registered under and `tracker()` resolves clients by key — renaming it to
// the declared `googletagmanager` would silently stop every event from publishing.
interface PurchaseAnalyticsConfig extends IConfig {
  gtm: GoogleTagManagerClient;
}

const config: PurchaseAnalyticsConfig = {
  gtm: new GoogleTagManagerClient({
    id: process.env.ANALYTICS_GOOGLE_TAG_MANAGER_ID
  }),
  debug: process.env.NODE_ENV !== 'production',
  noPublish: false
};

export default new CreateConfig(config);
